<template>
  <div class="section">
    <div v-show="form.charterFlightOrCharterVessel === 1" style="margin-bottom: 10px; height: 100%">
      <div style="float: right; margin-bottom: 5px">
        <el-button no="1" type="primary" @click="onCostAdd">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
        <el-button no="2" type="danger" @click="onCostDel">{{ $t('SeaExport.Delete') }}</el-button>
      </div>
      <cargo-ag-grid
        no="3"
        config-module="150010"
        :grid-options="costGrid.gridOptions"
        :column-defs="costGridColumnDefs"
        :row-data="costGrid.rowData"
        style="height: 100%;"
        @gridReady="params=>{costGrid.gridApi=params.api}"
      />
    </div>
    <div v-show="form.charterFlightOrCharterVessel === 2" style="margin-bottom: 10px; height: 100%">
      <cargo-left-right-resize
        :left-style="{ width: '30%', }"
        :right-style="{ width: '70%',}"
        style="min-height:100%"
      >
        <template slot="left">
          <div style="float: right; margin: 10px 0px">
            <el-button no="4" type="primary" @click="onAirplaneContainerAdd">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <el-button no="5" type="danger" @click="onAirplaneContainerDel">{{ $t('SeaExport.Delete') }}</el-button>
          </div>
          <cargo-ag-grid
            no="6"
            config-module="150011"
            :grid-options="airplaneContainerGrid.gridOptions"
            :column-defs="airplaneContainerGrid.columnDefs"
            :row-data="airplaneContainerGrid.rowData"
            style="height: 100%;"
            @gridReady="params=>{airplaneContainerGrid.gridApi=params.api}"
          />
        </template>
        <template slot="right">
          <div style="float: right; margin: 10px 0px">
            <el-button no="7" type="primary" @click="onVesselCostAdd">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <el-button no="8" type="danger" @click="onVesselCostDel">{{ $t('SeaExport.Delete') }}</el-button>
          </div>
          <cargo-ag-grid
            no="9"
            config-module="150010"
            :grid-options="costVesselGrid.gridOptions"
            :column-defs="costVesselGridColumnDefs"
            :row-data="costVesselGrid.rowData"
            style="height: 100%;"
            @gridReady="params=>{costVesselGrid.gridApi=params.api}"
          />
        </template>
      </cargo-left-right-resize>
    </div>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'

export default {
  name: 'FlightCosts',
  components: { CargoLeftRightResize },
  props: {
    form: { type: Object, default: () => {} }
  },
  data() {
    return {
      selectedItem: null,
      delFlightContainerKeys: [],
      delFlightFeesKeys: [],
      costGrid: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor
          }
        },
        rowData: [],
        gridApi: null
      },
      costVesselGrid: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor
          }
        },
        rowData: [],
        gridApi: null
      },
      airplaneContainerGrid: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor
          },
          onRowClicked: (event) => {
            const data = event.data
            this.selectedItem = data
            if (!data) {
              this.costVesselGrid.rowData = []
            }
            if (!this.selectedItem.flightDescriptionFees) {
              this.selectedItem.flightDescriptionFees = []
            }
            // 切换费用
            this.costVesselGrid.rowData = this.selectedItem.flightDescriptionFees
          }
        },
        columnDefs: [
          {
            headerName: '', width: 55, checkboxSelection: true,
            pinned: 'left',
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
            field: 'serialNumber',
            cellEditor: 'CargoAgGridCommonInputEditor',
            flex: 1
          }, {
            headerName: this.$t('CargoMsg.Cargo_ApplicableContainerCode'),
            field: 'containerCode',
            editable: true,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_AirplaneContainer,
                filterable: true,
                tagName: 'code',
                tagValue: 'code',
                filterTagNames: ['code']
              }
            },
            valueFormatter: params => {
              return params.value
            },
            flex: 1
          }
        ],
        rowData: [],
        gridApi: null
      }
    }
  },
  computed: {
    costGridColumnDefs() {
      return [
        {
          headerName: '', width: 55, checkboxSelection: true,
          pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          cellEditor: 'CargoAgGridCommonInputEditor',
          width: 100
        }, {
          headerName: this.$t('SeaExport.ChargeItem'),
          field: 'chargeItemId',
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const methodParams = {
              active: true
            }
            if (this.form.charterFlightOrCharterVessel === 1) {
              methodParams['charterFlight'] = true
            }
            if (this.form.charterFlightOrCharterVessel === 2) {
              methodParams['charterVessel'] = true
            }
            return {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_ChargeItem,
                methodParams: methodParams,
                filterable: true,
                tagValue: 'itemId',
                tagName: 'zhName',
                filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
                filterType: 'global'
              }
            }
          },
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        }, {
          headerName: this.$t('SeaExport.Currency'),
          field: 'currency',
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Currency,
              filterable: true,
              tagName: 'code',
              tagValue: 'code',
              filterTagNames: ['code']
            }
          },
          valueFormatter: params => {
            return params.value
          },
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Amount'),
          field: 'amount',
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remarks',
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          width: 180
        }
      ]
    },
    costVesselGridColumnDefs() {
      return [
        {
          headerName: '', width: 55, checkboxSelection: true,
          pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          cellEditor: 'CargoAgGridCommonInputEditor',
          width: 100
        }, {
          headerName: this.$t('SeaExport.ChargeItem'),
          field: 'chargeItemId',
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const methodParams = {
              active: true
            }
            if (this.form.charterFlightOrCharterVessel === 1) {
              methodParams['charterFlight'] = true
            }
            if (this.form.charterFlightOrCharterVessel === 2) {
              methodParams['charterVessel'] = true
            }
            return {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_ChargeItem,
                methodParams: methodParams,
                filterable: true,
                tagValue: 'itemId',
                tagName: 'zhName',
                filterTagNames: ['code']
              }
            }
          },
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        }, {
          headerName: this.$t('SeaExport.Currency'),
          field: 'currency',
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Currency,
              filterable: true,
              tagName: 'code',
              tagValue: 'code',
              filterTagNames: ['code']
            }
          },
          valueFormatter: params => {
            return params.value
          },
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Amount'),
          field: 'amount',
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remarks',
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          width: 180
        }
      ]
    }
  },
  methods: {
    init(form) {
      const { charterFlightOrCharterVessel, flightDescriptionFees, flightDescriptionContainers } = form
      this.costGrid.rowData = []
      this.costVesselGrid.rowData = []
      if (charterFlightOrCharterVessel === 1) {
        this.costGrid.rowData = flightDescriptionFees || []
      }
      this.airplaneContainerGrid.rowData = flightDescriptionContainers || []
      form.flightDescriptionFees = this.costGrid.rowData
      form.flightDescriptionContainers = this.airplaneContainerGrid.rowData
      this.airplaneContainerGrid.gridOptions.api.clearFocusedCell()
    },
    onCostAdd() {
      this.costAdd(this.costGrid)
    },
    onVesselCostAdd() {
      // 判断是否选中数据
      if (!this.selectedItem) {
        this.$message.warning(this.$t('CargoMsg.cargo_Please_select_a_container'))
        return
      }
      this.costAdd(this.costVesselGrid)
    },
    onVesselCostDel() {
      this.commonDel(this.costVesselGrid, this.delFlightFeesKeys)
    },
    costAdd(grid) {
      const length = grid.rowData.length + 1
      const data = {
        serialNumber: length,
        flightDescriptionUuid: this.form.uuid,
        containerCode: '',
        containerNumber: ''
      }
      grid.rowData.push(data)
    },
    onCostDel() {
      this.commonDel(this.costGrid, this.delFlightFeesKeys)
    },
    commonDel(grid, delKeys) {
      const rows = grid.gridOptions.api.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (grid.rowData) {
        for (let i = grid.rowData.length - 1; i >= 0; --i) {
          const row = grid.rowData[i]
          if (rows.includes(row)) {
            if (row.uuid) {
              delKeys.push(row.uuid)
            }
            if (row.flightDescriptionFees && row.flightDescriptionFees.length > 0) {
              // 如果是集装器，同步移除费用
              for (const fees of row.flightDescriptionFees) {
                if (fees.uuid) {
                  this.delFlightFeesKeys.push(fees.uuid)
                }
              }
              row.flightDescriptionFees = []
              // 如果是选中的集装器
              if (this.selectedItem.uuid === row.uuid) {
                this.costVesselGrid.rowData = []
                this.selectedItem = null
              }
            }
            grid.rowData.splice(i, 1)
          }
        }
      }
      const tempRowData = grid.rowData
      grid.rowData = []
      this.$nextTick(() => {
        // 重置序号
        for (let i = 0; i < tempRowData.length; i++) {
          const data = tempRowData[i]
          data.serialNumber = i + 1
        }
        grid.rowData = tempRowData

        grid.gridOptions.api.refreshCells({ force: true })
        grid.gridOptions.api.clearFocusedCell()
      })
    },
    onAirplaneContainerAdd() {
      const length = this.airplaneContainerGrid.rowData.length + 1
      const data = {
        flightDescriptionUuid: this.form.uuid,
        serialNumber: length,
        chargeItemId: 0,
        currency: '',
        amount: 0,
        remarks: '',
        flightDescriptionFees: []
      }
      this.airplaneContainerGrid.rowData.push(data)
      this.airplaneContainerGrid.gridOptions.api.refreshCells({ force: true })
      this.airplaneContainerGrid.gridOptions.api.clearFocusedCell()
      this.selectedItem = null
    },
    onAirplaneContainerDel() {
      this.commonDel(this.airplaneContainerGrid, this.delFlightContainerKeys)
      this.selectedItem = null
      // 清空选中
    },
    commitSave() {
      if (this.form.charterFlightOrCharterVessel === 0) {
        // 为空时，只考虑删除数据
        this.removeContainers()
        this.removeCost(this.costGrid)
      }
      if (this.form.charterFlightOrCharterVessel === 1) {
        this.removeContainers()
      }
      if (this.form.charterFlightOrCharterVessel === 2) {
        this.removeCost(this.costGrid)
      }
      return {
        flightDescriptionFees: this.costGrid.rowData,
        flightDescriptionContainers: this.airplaneContainerGrid.rowData,
        delFlightFeesKeys: this.delFlightFeesKeys,
        delFlightContainerKeys: this.delFlightContainerKeys
      }
    },
    // 航班成本数据校验
    checkFlightCost() {
      if (this.form.charterFlightOrCharterVessel === 2) {
        const containers = this.airplaneContainerGrid.rowData
        if (!containers || containers.length === 0) {
          // 没有维护集装器
          this.$message.warning(this.$t('CargoMsg.cargo_please_enter_the_container'))
          return false
        }
        this.airplaneContainerGrid.gridApi.forEachNode(node => {
          const item = node.data
          const rowIndex = node.rowIndex
          if (!item.containerCode) {
            this.$message.warning(this.$t('CargoMsg.cargo_please_enter_the_container_code'))
            this.airplaneContainerGrid.gridApi.startEditingCell({ rowIndex, colKey: 'containerCode' })
            throw new Error()
          }
        })
        if (!this.checkCost(this.costVesselGrid)) {
          return false
        }
      }

      if (this.form.charterFlightOrCharterVessel === 1) {
        if (!this.checkCost(this.costGrid)) {
          return false
        }
      }
      return true
    },
    checkCost(grid) {
      const rowData = grid.rowData
      if (!rowData || rowData.length === 0) {
        // 没有维护集装器
        this.$message.warning(this.$t('CargoMsg.Cargo_please_enter_flight_costs'))
        return false
      }
      let chargeItemFlag = false
      grid.gridApi.forEachNode(node => {
        const item = node.data
        const rowIndex = node.rowIndex
        if (!item.chargeItemId) {
          this.$message.warning(this.$t('Pricing.FeeNameIsNull'))
          grid.gridApi.startEditingCell({ rowIndex, colKey: 'chargeItemId' })
          chargeItemFlag = true
          throw new Error()
        }
      })
      if (chargeItemFlag) {
        return false
      }
      return true
    },
    removeContainers() {
      const delFlightFeesKeys = []
      const delFlightContainerKeys = []
      for (const item of this.airplaneContainerGrid.rowData) {
        if (item.uuid) {
          delFlightContainerKeys.push(item.uuid)
        }
        // 同步移除关联费用
        if (item.flightDescriptionFees && item.flightDescriptionFees.length > 0) {
          for (const fees of item.flightDescriptionFees) {
            if (fees.uuid) {
              delFlightFeesKeys.push(fees.uuid)
            }
          }
        }
      }
      this.delFlightContainerKeys = this.delFlightContainerKeys.concat(delFlightContainerKeys)
      this.delFlightFeesKeys = this.delFlightFeesKeys.concat(delFlightFeesKeys)
      this.airplaneContainerGrid.rowData = []
    },
    removeCost(grid) {
      const delFlightCostKeys = []
      for (const item of grid.rowData) {
        if (item.uuid) {
          delFlightCostKeys.push(item.uuid)
        }
      }
      this.delFlightFeesKeys = this.delFlightFeesKeys.concat(delFlightCostKeys)
      grid.rowData = []
    }
  }
}
</script>

<style scoped>

</style>
